import React from "react";


export default function CustomSvg({ name, width, height, color }) {
  return (
    name == 'libraryLogo'
      ?
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
        width={width || 32} height={height || 32} viewBox="0 0 300.000000 300.000000"
        preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,300.000000) scale(0.100000,-0.100000)" fill={color || '#000'} stroke="none">
          <path d="M797 2989 c-14 -9 -17 -27 -17 -124 l0 -114 -57 24 c-32 12 -91 31
                    -132 41 l-74 17 -19 -23 c-18 -22 -19 -41 -16 -327 l3 -304 -25 -5 c-57 -12
                    -236 -77 -252 -91 -10 -9 -18 -22 -18 -30 0 -9 -17 -13 -64 -13 -53 0 -67 -4
                    -90 -25 -14 -13 -26 -31 -26 -39 0 -8 -3 -23 -7 -33 -5 -12 5 -8 30 15 40 34
                    58 42 36 15 -11 -13 -15 -139 -19 -687 l-5 -671 -22 -3 c-27 -4 -30 -24 -7
                    -46 18 -18 32 -20 54 -6 13 8 16 101 20 701 l5 692 47 2 48 2 0 -873 c0 -780
                    2 -874 16 -888 14 -14 145 -16 1294 -16 1149 0 1280 2 1294 16 14 14 16 108
                    16 888 l0 873 48 -2 47 -2 3 -931 2 -932 -640 0 -641 0 -30 23 c-44 32 -154
                    32 -198 0 l-30 -23 -641 0 -640 0 0 128 c0 86 -4 132 -12 140 -18 18 -56 14
                    -68 -7 -16 -30 -12 -41 13 -38 21 2 22 -1 27 -115 4 -102 8 -119 25 -132 17
                    -14 102 -15 673 -13 358 1 652 1 652 -1 0 -2 -7 -10 -16 -19 -26 -26 0 -40 32
                    -17 73 52 103 53 156 9 16 -14 33 -25 38 -25 17 0 20 18 5 30 -8 7 -15 15 -15
                    19 0 3 293 5 652 3 l651 -2 24 22 23 21 0 932 c0 731 -3 934 -12 945 -7 7 5 0
                    26 -16 31 -23 38 -25 33 -11 -4 10 -7 25 -7 33 0 8 -12 26 -26 39 -23 21 -37
                    25 -90 25 -47 0 -64 4 -64 13 0 23 -31 44 -105 70 l-70 25 -3 155 c-2 125 -5
                    157 -18 168 -12 10 -43 10 -158 0 -153 -13 -304 -43 -431 -86 -119 -40 -309
                    -137 -403 -205 -46 -33 -85 -60 -86 -60 -2 0 -6 33 -9 73 -19 215 -153 485
                    -306 614 -134 114 -366 214 -424 182z m63 -39 c12 -7 12 -12 -4 -29 -26 -29
                    -36 -26 -36 9 0 31 13 37 40 20z m150 -107 c175 -84 320 -261 389 -473 54
                    -167 54 -161 58 -950 3 -448 1 -731 -5 -725 -5 6 -14 25 -21 44 -20 60 -102
                    182 -165 246 -99 100 -242 186 -360 216 l-46 11 0 845 0 845 28 -6 c15 -4 70
                    -28 122 -53z m-440 -71 c0 -5 -9 -17 -20 -27 -20 -18 -20 -17 -20 8 0 20 5 27
                    20 27 11 0 20 -4 20 -8z m250 -57 c0 -43 -1 -45 -21 -35 -31 17 -34 38 -8 60
                    13 10 25 19 27 20 1 0 2 -20 2 -45z m-135 -19 l90 -32 3 -754 c1 -415 6 -758
                    10 -762 5 -5 41 -17 82 -29 211 -58 370 -190 470 -389 38 -75 106 -277 97
                    -286 -2 -3 -25 24 -51 60 -92 129 -267 286 -425 380 -85 52 -216 109 -312 137
                    l-79 23 0 843 c0 668 3 843 13 842 6 0 53 -15 102 -33z m1867 -548 l3 -243 35
                    0 35 0 3 77 3 77 44 -17 45 -16 0 -802 0 -802 -62 20 c-167 52 -478 75 -634
                    48 -87 -16 -93 -19 -70 -35 17 -13 14 -15 -25 -25 -117 -31 -159 -45 -224 -75
                    -38 -17 -78 -41 -89 -53 -17 -20 -17 -23 -3 -46 9 -13 13 -26 10 -30 -8 -8
                    -238 -8 -246 0 -3 4 1 17 10 31 15 23 15 25 -12 53 l-28 29 27 23 c24 20 26
                    27 17 51 -12 30 -9 32 20 16 51 -27 64 49 28 161 -43 136 -41 124 -20 106 23
                    -21 45 -20 62 1 12 14 15 -9 19 -159 4 -155 7 -178 24 -197 11 -12 25 -21 32
                    -21 7 0 58 29 112 65 107 70 269 152 279 141 4 -3 1 -12 -5 -18 -25 -25 -9
                    -23 101 14 150 48 305 78 449 85 74 4 122 10 128 18 7 8 9 198 8 546 l-3 534
                    -35 0 -35 0 -3 -501 -2 -502 -83 -7 c-327 -26 -634 -136 -870 -312 l-57 -43 2
                    837 3 837 90 68 c98 74 278 171 393 212 145 52 347 92 474 95 l48 1 2 -242z
                    m-2022 -18 c0 -45 -8 -49 -35 -20 -17 19 -17 21 0 40 27 29 35 25 35 -20z
                    m2095 -10 c18 -20 18 -21 -8 -48 l-27 -27 0 48 c0 52 8 57 35 27z m-1094 -18
                    l36 -18 -34 -39 c-26 -30 -33 -34 -33 -19 0 10 -3 36 -6 57 -4 20 -5 37 -2 37
                    2 0 20 -8 39 -18z m-1049 -552 c-2 -363 1 -546 8 -560 6 -11 29 -24 53 -30
                    240 -62 443 -172 614 -333 81 -77 227 -247 219 -255 -2 -2 -26 8 -53 21 -71
                    36 -194 73 -311 92 -195 33 -514 10 -689 -49 l-43 -15 0 803 0 804 93 30 c50
                    17 97 31 102 31 7 1 9 -183 7 -539z m-234 469 c-6 -19 -13 -40 -15 -48 -3 -11
                    -9 -10 -26 8 l-22 22 33 30 c19 17 36 29 38 27 2 -3 -1 -20 -8 -39z m2546 2
                    c18 -20 18 -22 1 -41 -26 -29 -35 -25 -35 14 0 19 -4 38 -10 41 -5 3 -10 11
                    -10 16 0 13 30 -3 54 -30z m-2527 -1661 c-25 -31 -37 -22 -37 26 0 42 9 48 36
                    23 l23 -22 -22 -27z m763 34 c96 -18 202 -52 290 -92 l65 -31 -552 0 -553 -1
                    0 33 0 33 108 27 c99 25 189 41 287 51 70 7 273 -4 355 -20z m1410 6 c36 -6
                    113 -22 173 -37 l107 -26 0 -34 0 -33 -550 0 c-302 0 -550 2 -550 4 0 2 45 22
                    100 45 110 46 232 78 348 91 87 10 275 5 372 -10z m330 -14 c0 -45 -12 -51
                    -39 -22 l-22 24 22 16 c33 23 39 20 39 -18z"/>
          <path d="M6 83 c10 -42 43 -73 78 -73 l30 0 -39 40 c-22 22 -48 45 -58 51 -16
                    9 -17 7 -11 -18z"/>
          <path d="M2935 60 l-49 -50 30 0 c19 0 38 9 51 23 21 23 39 77 25 77 -4 0 -30
                    -22 -57 -50z"/>
        </g>
      </svg>
      :
      <></>
  )
}
